import React from "react";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components/macro";
import { LoadingMessage } from "../../odc-ui";

const LoadingMessageContainer = styled.div`
  margin: 10px 0;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 5px;
`;

const SquareCardFields = ({ onChange }) => {
  const [squareCard, setSquareCard] = useState();
  const [cardBrand, setCardBrand] = useState();
  const [loading, setLoading] = useState(true);

  const appId = window.gon.square_app_id;
  const locationId = window.gon.square_location_id;

  async function initializeCard(payments) {
    const card = await payments.card();
    await card.attach("#card-container");
    card.addEventListener("cardBrandChanged", (cardInputEvent) => {
      setCardBrand(cardInputEvent.detail.cardBrand);
    });
    setSquareCard(card);
  }

  async function setupSquareCardForm() {
    if (!window.Square) {
      throw new Error("Square.js failed to load properly");
    }
    const payments = window.Square.payments(appId, locationId);
    try {
      await initializeCard(payments);
      setLoading(false);
    } catch (e) {
      console.error("Initializing Card failed", e);
    }
  }

  useEffect(() => {
    if (onChange) {
      onChange(squareCard, cardBrand);
    }
  }, [squareCard, cardBrand]);

  useEffect(() => {
    setupSquareCardForm();
  }, []);

  return (
    <>
      <div id="card-container" />
      {loading && (
        <LoadingMessageContainer>
          <LoadingMessage message="Setting up form..." />
        </LoadingMessageContainer>
      )}
    </>
  );
};

SquareCardFields.propTypes = {
  onChange: PropTypes.func,
};

export default SquareCardFields;
